/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import {
  Button,
  Card,
  CardBody,
  Flex,
  FormControl,
  Checkbox,
  FormLabel
} from "@chakra-ui/react";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import {
  useLookupCashCenters,
  useLookupDesignations,
  useLookupNationalities
} from "../../services/lookups-queries";
import FormInput from "../../components/forms/form-Input";
import ReactHookFormDropdown from "../../components/forms/react-hook-dropdown";
import FormHookDatePicker from "../../components/forms/form-hook-date-picker";
import {
  useLookupAssignmentGroup,
  useLookupBusinessUnits,
  useLookupCities,
  useLookupClients,
  useLookupEmirates,
  useLookupOffices,
  useLookupRegions
} from "../../services/lookups-mutations";
import {
  useCreateUser,
  useEditUser,
  useGetRolesListQuery,
  useGetUserDetails,
  useGetUsersList,
  useVerifyEmployeeId
} from "../../services/auth-api";
import {
  accountStatus,
  accountTypes,
  editUserFormValued,
  formDefaultValues,
  staffTypes
} from "./constants";
import { getFormValidationRules } from "../../utils/formValidationRules";

import Swal from "sweetalert2";
import { Textarea } from "@repo/ui";
import { getLocalISODateString } from "utils/helper";

export default function AddUser() {
  const [roles, setRoles] = useState([]);
  const [assignmentGroups, setAssignmentGroups] = useState([]);
  const [existingId, setExistingId] = useState(null);

  const navigate = useNavigate();
  const params = useParams();
  const {
    mutate: createRequest,
    isSuccess: isRequestCreated,
    isPending: creatingRequest,
    error: createError,
    data: createUserData
  } = useCreateUser();
  const {
    mutate: editUserRequest,
    isSuccess: isUserEdited,
    isPending: editingUserRequest
  } = useEditUser();
  const { mutate: getUsersList } = useGetUsersList();
  const {
    data: cashCenterListRes,
    isPending: gettingCashCenterList,
    error: cashCenterError
  } = useLookupCashCenters();
  const {
    mutate: getAssignmentGroup,
    data: assignmentGroupRes,
    isPending: gettingAssignmentGroup,
    error: assignmentGroupError,
    reset: resetAssignmentGroups
  } = useLookupAssignmentGroup();

  const {
    data: nationalities,
    isPending: gettingNationalities,
    error: nationalitiesError
  } = useLookupNationalities();
  const {
    data: designations,
    isPending: gettingDesignations,
    error: designationError
  } = useLookupDesignations();
  const {
    data: rolesList,
    isSuccess: rolesAvailable,
    isPending: gettingRoles,
    error: rolesError
  } = useGetRolesListQuery();
  const {
    mutate: getOffices,
    data: officesData,
    isPending: gettingOffices,
    error: officesError,
    reset: resetOffices
  } = useLookupOffices();
  const {
    mutate: getRegions,
    data: regionsList,
    isPending: gettingRegions
  } = useLookupRegions();
  const {
    mutate: getCities,
    data: citiesList,
    isPending: gettingCities
  } = useLookupCities();
  const {
    mutate: getEmirates,
    data: emiratesList,
    isPending: gettingEmirates
  } = useLookupEmirates();
  const {
    mutate: getBusinessUnits,
    data: businessUnitsList,
    isPending: gettingBusinessUnits
  } = useLookupBusinessUnits();
  const {
    mutate: editUser,
    data: userData,
    isPending: gettingUser,
    error: userError,
    reset: resetUser
  } = useGetUserDetails();
  const {
    mutate: getClients,
    data: clientsList,
    isPending: gettingClient
  } = useLookupClients();
  const {
    mutate: verifyEmployeeId,
    data: employeeIdVerificationRes,
    isPending: verifyingEmployeeId,
    reset: resetVerifyEmployeeId
  } = useVerifyEmployeeId();

  const {
    handleSubmit,
    setValue,
    control,
    getValues,
    reset,
    setError,
    clearErrors,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: { ...formDefaultValues }
  });

  const formValidationRules = getFormValidationRules({
    params,
    getValues,
    resetVerifyEmployeeId,
    employeeIdVerificationRes,
    existingId,
    setError,
    clearErrors,
    errors
  });
  const generalFieldProps = { errors, control };

  const {
    fields: rolesFields,
    remove: removeRole,
    append: appendRole
  } = useFieldArray({
    control: generalFieldProps.control,
    name: "roles"
  });

  useEffect(() => {
    if (params.userId) {
      editUser(params.userId);
    }
    getEmirates("UAE");
    getRegions("UAE");
    getCities("UAE");
    getBusinessUnits();
    getAssignmentGroup();
    getClients();
    getUsersList();
  }, []);

  useEffect(() => {
    if (isRequestCreated) {
      if (getValues("isAzureAd") === "No") {
        Swal.fire({
          icon: "success",
          title: `<h4 style="margin: 0; font-size: 20px">User created successfully!</h4>`,
          html: `
              <div style="text-align: left;">
                
                <div style="font-size: 16px; display: flex; align-items: center; gap: 8px; margin-bottom: 15px;">
                  <span style="white-space: nowrap;">Temporary Password:</span>
                  <input 
                    readonly
                    id="tempPassInput" 
                    style="padding: 6px; border: 1px solid #ddd; border-radius: 4px; flex: 1;"
                  value="${createUserData?.data?.tempPassword || ""}"
                    />
                <button id="copyBtn" style="padding: 8px 10px; background: #f31700; color: white; border: none; border-radius: 4px; cursor: pointer; white-space: nowrap; font-size: 14px;">
                  Copy
                </button>
              </div>
              <div style="background: #fff8e1; padding: 4px; border-left: 4px solid #ffc107; margin: 10px 0 0; font-size:12px">
              <p style="margin: 0;"><strong>⚠️ Important:</strong></p>
              <ul style="margin: 5px 0 0 15px; padding-left: 5px; list-style: disc; text-align: left;">
                <li>You must <strong>save this password now</strong> - it won't be shown again</li>
                <li><strong>Share it securely</strong> with the user immediately</li>
                <li>If lost, the user will need to <strong>request a password reset</strong></li>
                <li>Expires on: <strong>${createUserData?.data?.expiryDate?.split("T")[0] || ""}</strong></li>
              </ul>
            </div>
            `,
          didOpen: () => {
            const copyButton = document.getElementById("copyBtn");
            copyButton.addEventListener("click", () => {
              const tempPassInput = document.getElementById("tempPassInput");
              tempPassInput.select();
              document.execCommand("copy");
              // Visual feedback
              copyButton.textContent = "Copied!";
              copyButton.style.background = "#28a745";
              setTimeout(() => {
                copyButton.textContent = "Copy";
                copyButton.style.background = "#f31700";
              }, 1500);
            });
          },
          confirmButtonText: "Close",
          allowOutsideClick: false
        }).then(() => {
          navigate(Paths.users);
        });
      } else {
        Swal.fire({
          icon: "success",
          title: `<h4 style="margin: 0; font-size: 20px">User created successfully!</h4>`,
          text: "User successfully registered in Lynx platform. He/She can use it's Azure Entra Id credentials to login into Lynx."
        }).then(() => {
          navigate(Paths.users);
        });
      }
      reset();
    }
  }, [isRequestCreated]);

  useEffect(() => {
    if (rolesAvailable) {
      setRoles(rolesList.data);
    }
    if (employeeIdVerificationRes) {
      setError("employeeId", {
        type: "validate",
        message: "User Already Exist. Please Enter  Different Employee Id"
      });
      // setExistingId(watch("employeeId"));
    }
    if (isUserEdited) {
      reset();
      navigate(Paths.users);
      return;
    }

    if (
      userData &&
      ((userData.data.cashCenterId &&
        userData.data.accountType === "Internal" &&
        officesData) ||
        !userData?.data.cashCenterId ||
        userData?.data.accountType !== "Internal") &&
      cashCenterListRes &&
      nationalities &&
      designations &&
      rolesList &&
      clientsList &&
      assignmentGroups.length > 0
    ) {
      reset(editUserFormValued(userData.data, rolesList.data));

      resetUser();
      setExistingId(watch("employeeId"));
    }

    if (assignmentGroupRes) {
      setAssignmentGroups(
        assignmentGroupRes.data.map((elm) => ({
          label: elm.name,
          value: elm.name
        }))
      );
      resetAssignmentGroups();
    }
  }, [
    userData,
    officesData,
    cashCenterListRes,
    nationalities,
    designations,
    rolesList,
    officesData,
    rolesAvailable,
    isRequestCreated,
    createError,
    cashCenterError,
    nationalitiesError,
    designationError,
    rolesError,
    officesError,
    userError,
    isUserEdited,
    assignmentGroupError,
    assignmentGroupRes,
    assignmentGroups,
    clientsList,
    employeeIdVerificationRes
  ]);
  useEffect(() => {
    if (
      userData &&
      userData.data.cashCenterId &&
      userData.data.accountType === "Internal"
    ) {
      getOffices(userData.data.cashCenterId);
    }
  }, [userData]);

  const handleBlur = (e) => {
    if (e.target.value !== existingId) {
      verifyEmployeeId(watch("employeeId"));
    }
  };

  const handleCancel = () => {
    navigate(Paths.users);
  };

  const onSubmit = (data) => {
    if (employeeIdVerificationRes) {
      setError("employeeId", {
        type: "validate",
        message: "User Already Exist. Please Enter  Different Employee Id"
      });
      return;
    }
    const _payload = {
      employeeId: data.employeeId,
      cenconId: data.cenconId || "",
      firstName: data.firstName,
      lastName: data.lastName,
      userName: data.userName,
      email: data.email,
      mobileNo: data.mobileNo,
      designation: data.designation,
      assignment: data.assignment || "",
      status: data.status || "",
      accountType: data.accountType,
      staffType: data.staffType,
      businessUnit: data.businessUnit,
      state: data.state || "",
      city: data.city || "",
      emirate: data.emirate || "",
      managerId: data.managerId || "",
      cashCenterId: data.cashCenterId,
      officeId: data.officeId,
      clientId: data.clientId || "",
      personalEmail: data.personalEmail || "",
      personalMobileNo: data.personalMobileNo || "",
      dateOfBirth: data.dateOfBirth
        ? getLocalISODateString(data.dateOfBirth)
        : null,
      dateOfJoining: data.dateOfJoining
        ? getLocalISODateString(data.dateOfJoining)
        : null,

      nationality: data.nationality,
      nationalId: data.nationalId,
      nationalIdExpiry: data.nationalIdExpiry
        ? getLocalISODateString(data.nationalIdExpiry)
        : null,
      passportNo: data.passportNumber || "",
      passportExpiry: data.passportExpiry
        ? getLocalISODateString(data.passportExpiry)
        : null,
      drivingLicenseNo: data.drivingLicenseNo || "",
      drivingLicenseExpiry: data.drivingExpiry
        ? getLocalISODateString(data.drivingExpiry)
        : null,
      isAzureAd: Boolean(data.isAzureAd === "Yes"),
      roles: data.roles.map((role) => role.name),
      regulatoryId: data.regulatoryId || "",
      requestedBy: data.requestedBy || "",
      comments: data.comments || ""
    };
    if (params.userId) {
      editUserRequest({
        userName: _payload.userName,
        employeeId: _payload.employeeId,
        firstName: _payload.firstName,
        lastName: _payload.lastName,
        email: _payload.email,
        mobileNo: _payload.mobileNo,
        designation: _payload.designation,
        assignment: _payload.assignment,
        status: _payload.status,
        accountType: _payload.accountType,
        staffType: _payload.staffType,
        businessUnit: _payload.businessUnit,
        managerId: _payload.managerId,
        state: _payload.state,
        city: _payload.city,
        emirate: _payload.emirate,
        cenconId: _payload.cenconId,
        cashCenterId: _payload.cashCenterId,
        officeId: _payload.officeId,
        clientId: _payload.clientId,
        personalEmail: _payload.personalEmail ? _payload.personalEmail : null,
        personalMobileNo: _payload.personalMobileNo,
        dateOfBirth: _payload.dateOfBirth,
        dateOfJoining: _payload.dateOfJoining,
        nationality: _payload.nationality,
        nationalId: _payload.nationalId,
        nationalIdExpiry: _payload.nationalIdExpiry,
        passportNo: _payload.passportNo,
        passportExpiry: _payload.passportExpiry,
        drivingLicenseNo: _payload.drivingLicenseNo,
        drivingLicenseExpiry: _payload.drivingLicenseExpiry,
        roles: _payload.roles,
        isAzureAd: Boolean(data.isAzureAd === "Yes"),
        regulatoryId: data.regulatoryId || "",
        requestedBy: data.requestedBy || "",
        comments: data.comments || ""
      });
      return;
    }

    createRequest(_payload);
  };

  const onCashCentersChanged = (cashCenterId) => {
    setValue("officeId", null, { shouldValidate: true });
    getOffices(cashCenterId);
    setValue("cashCenterId", cashCenterId);
  };

  const onRolesChange = (role) => {
    const roleFoundIndex = rolesFields.findIndex(
      (elm) => elm.name === role.name
    );
    if (roleFoundIndex === -1) {
      appendRole({ name: role.name });
    } else {
      removeRole(roleFoundIndex);
    }
  };
  const onAccountTypeChange = (value) => {
    // const value = event.value;

    if (value === "External") {
      setValue("cashCenterId", null);
      setValue("officeId", null);
      resetOffices();
    }
    if (value === "Internal") {
      setValue("clientId", null);
    }
    setValue("assignment", "");
    clearErrors(["cashCenterId", "officeId", "accountType"]);
  };

  return (
    <>
      {creatingRequest ||
      gettingCashCenterList ||
      editingUserRequest ||
      gettingDesignations ||
      gettingOffices ||
      gettingRoles ||
      gettingRegions ||
      gettingCities ||
      gettingEmirates ||
      gettingBusinessUnits ||
      gettingAssignmentGroup ||
      gettingNationalities ||
      verifyingEmployeeId ||
      gettingClient ||
      gettingUser ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="p-4 space-y-4 add-user-container">
        <BreadCrumb
          links={[
            { text: "Users", link: Paths.users },
            {
              text: params.userId ? "Edit User" : "Create User",
              isCurrentPage: true
            }
          ]}
        />

        <Flex w="100%">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4"
              >
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Employee Id"
                  name="employeeId"
                  rules={formValidationRules.employeeId}
                  info="Alphanumeric Only"
                  onBlur={handleBlur}
                  onChange={() => {
                    clearErrors(["employeeId"]);
                    resetVerifyEmployeeId();
                  }}
                  disabled={Boolean(params.userId)}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="User Name"
                  name="userName"
                  rules={formValidationRules.userName}
                  disabled={Boolean(params.userId)}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="First Name"
                  name="firstName"
                  rules={formValidationRules.firstName}
                  info="Alphabets Only"
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Last Name"
                  name="lastName"
                  rules={formValidationRules.lastName}
                  info="Alphabets Only"
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="AD User"
                  name="isAzureAd"
                  placeholder="Select "
                  data={[
                    { label: "Yes", value: "Yes" },
                    { label: "No", value: "No" }
                  ]}
                  rules={formValidationRules.nationality}
                  filterable
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Nationalities"
                  name="nationality"
                  placeholder="Select Nationality"
                  data={
                    nationalities?.data?.map((item) => ({
                      value: item.name,
                      label: item.name
                    })) || []
                  }
                  rules={formValidationRules.nationality}
                  filterable
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Email"
                  name="email"
                  rules={formValidationRules.email}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired={false}
                  label="Personal Email"
                  name="personalEmail"
                  rules={formValidationRules.personalEmail}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Mobile No"
                  name="mobileNo"
                  rules={formValidationRules.mobileNumber}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired={false}
                  label="Personal Mobile No"
                  name="personalMobileNo"
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Account Type"
                  name="accountType"
                  placeholder="Select Account Type"
                  data={accountTypes || []}
                  rules={formValidationRules.accountType}
                  filterable={false}
                  onChange={onAccountTypeChange}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Account Status"
                  name="status"
                  placeholder="Select Account Status"
                  data={accountStatus || []}
                  rules={formValidationRules.status}
                  filterable={false}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Designation"
                  name="designation"
                  placeholder="Select Designation"
                  data={
                    designations?.data?.map((item) => ({
                      value: item.description,
                      label: item.description
                    })) || []
                  }
                  rules={formValidationRules.designation}
                  filterable
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Assignment"
                  name="assignment"
                  placeholder="Select Assignment"
                  data={
                    assignmentGroups?.filter((elm) => {
                      const isExternal = watch("accountType") === "External";
                      return isExternal
                        ? elm.value === "Customer" || elm.value === "Hub"
                        : elm.value !== "Customer";
                    }) || []
                  }
                  rules={formValidationRules.assignment}
                  filterable={false}
                />
                <FormHookDatePicker
                  {...generalFieldProps}
                  label="Date of Birth"
                  name="dateOfBirth"
                  datePickerProps={{ placeholder: "Select Date" }}
                />
                <FormHookDatePicker
                  {...generalFieldProps}
                  label="Date of Joining"
                  name="dateOfJoining"
                  datePickerProps={{ placeholder: "Select Date" }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="National Id"
                  name="nationalId"
                  rules={formValidationRules.nationalId}
                  info="Only Alphanumeric Allowed"
                />
                <FormHookDatePicker
                  {...generalFieldProps}
                  label="National Id Expiry"
                  name="nationalIdExpiry"
                  datePickerProps={{ placeholder: "Select Date" }}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired={false}
                  label="Passport No"
                  name="passportNumber"
                  rules={formValidationRules.passportNumber}
                  info="Only Alphanumeric Allowed"
                />
                <FormHookDatePicker
                  {...generalFieldProps}
                  label="Passport Expiry"
                  name="passportExpiry"
                  datePickerProps={{ placeholder: "Select Date" }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Driving License No"
                  name="drivingLicenseNo"
                  rules={formValidationRules.drivingLicenseNo}
                />
                <FormHookDatePicker
                  {...generalFieldProps}
                  label="Driving Expiry"
                  name="drivingExpiry"
                  datePickerProps={{ placeholder: "Select Date" }}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  label="Cash Center"
                  name="cashCenterId"
                  disabled={watch("accountType") !== "Internal"}
                  isRequired={watch("accountType") === "Internal"}
                  data={
                    cashCenterListRes?.data.map((item) => ({
                      value: item.cashCenterId,
                      label: item.name
                    })) || []
                  }
                  placeholder="Select Cash Center"
                  dropdownProps={{ filterable: false }}
                  rules={formValidationRules.cashCenter}
                  onChange={onCashCentersChanged}
                  info={
                    watch("accountType") === "Internal"
                      ? ""
                      : "Applicable For Internal Account Type"
                  }
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  label="Office"
                  name="officeId"
                  disabled={
                    !(
                      watch("accountType") === "Internal" &&
                      watch("cashCenterId")
                    )
                  }
                  isRequired={watch("accountType") === "Internal"}
                  data={
                    officesData?.data?.map((item) => ({
                      value: item.officeId,
                      label: item.officeName
                    })) || []
                  }
                  placeholder="Select Office"
                  rules={formValidationRules.officeId}
                  dropdownProps={{ filterable: false }}
                  info={
                    watch("accountType") !== "Internal"
                      ? "Applicable For Internal Account Type"
                      : !watch("cashCenterId")
                        ? "Select Cash Center"
                        : ""
                  }
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  disabled={watch("accountType") === "Internal"}
                  isRequired={watch("accountType") === "External"}
                  data={
                    clientsList?.data.map((elm) => ({
                      value: elm.clientId,
                      label: `${elm.name} (${elm.type})`
                    })) || []
                  }
                  label="Client Id"
                  name="clientId"
                  rules={formValidationRules.clientId}
                  placeholder="Select Client"
                  dropdownProps={{ filterable: false }}
                  info={
                    watch("accountType") === "External"
                      ? ""
                      : "Applicable For External Account Type"
                  }
                />
                <FormInput
                  {...generalFieldProps}
                  label="Cencon Id"
                  name="cenconId"
                  rules={formValidationRules.cenconId}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  label="Staff Type"
                  name="staffType"
                  data={staffTypes || []}
                  placeholder="Select Staff Type"
                  dropdownProps={{ filterable: false }}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  label="Business Unit"
                  name="businessUnit"
                  data={
                    businessUnitsList?.data.map((elm) => ({
                      value: elm.name,
                      label: elm.name
                    })) || []
                  }
                  placeholder="Select Business Unit"
                  dropdownProps={{ filterable: false }}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  label="City"
                  name="city"
                  data={
                    citiesList?.data.map((elm) => ({
                      value: elm.name,
                      label: elm.name
                    })) || []
                  }
                  placeholder="Select City"
                  dropdownProps={{ filterable: false }}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  label="State"
                  name="state"
                  data={
                    regionsList?.data.map((elm) => ({
                      value: elm.name,
                      label: elm.name
                    })) || []
                  }
                  placeholder="Select Regions"
                  dropdownProps={{ filterable: false }}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  label="Emirate"
                  name="emirate"
                  data={
                    emiratesList?.data.map((elm) => ({
                      value: elm.name,
                      label: elm.name
                    })) || []
                  }
                  placeholder="Select Emirates"
                  dropdownProps={{ filterable: false }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Manager Id"
                  name="managerId"
                  rules={formValidationRules.managerId}
                />{" "}
                <FormInput
                  {...generalFieldProps}
                  label="Regulatory Id"
                  name="regulatoryId"
                />
                <FormInput
                  {...generalFieldProps}
                  label="Requested By"
                  name="requestedBy"
                />
                <div
                  className="full-width-field"
                  style={{ gridColumn: "span 4" }}
                >
                  {" "}
                  <FormControl>
                    <FormLabel>Comments</FormLabel>
                    <Controller
                      control={control}
                      name="comments"
                      render={({ field }) => (
                        <Textarea
                          value={field.value}
                          onChange={(e) => field.onChange(e.target.value)}
                        />
                      )}
                    />
                  </FormControl>
                </div>
                {/* Roles section spans full width */}
                <FormControl
                  style={{ width: "100%" }}
                  isRequired
                  className="col-span-1 md:col-span-2 lg:col-span-4"
                >
                  <Controller
                    control={control}
                    name="roles"
                    rules={formValidationRules.roles}
                    render={() => {
                      return <FormLabel>Select Roles</FormLabel>;
                    }}
                  />

                  {errors.roles ? (
                    <p className="text-red-500 text-xs">Please Select Roles</p>
                  ) : null}
                </FormControl>
                {roles.map((role, index) => {
                  return (
                    <FormControl key={`${role.name}-${index}`}>
                      <Checkbox
                        isChecked={
                          rolesFields.findIndex(
                            (elm) => elm.name === role.name
                          ) !== -1
                        }
                        name={role.name}
                        id={role.name}
                        onChange={() => onRolesChange(role)}
                      >
                        <FormLabel
                          style={{ marginBottom: 0 }}
                          htmlFor={role.name}
                        >
                          {role.name}
                        </FormLabel>
                      </Checkbox>
                    </FormControl>
                  );
                })}
                <Flex
                  className="col-span-1 md:col-span-2 lg:col-span-4"
                  w="100%"
                  justify="flex-end"
                  flexDirection="row"
                  gap={5}
                  disabled={verifyingEmployeeId}
                >
                  <Button type="cancel" onClick={handleCancel}>
                    Cancel
                  </Button>
                  <Button type="submit" disabled={employeeIdVerificationRes}>
                    {params.userId ? "Update" : "Submit"}
                  </Button>
                </Flex>
              </form>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
